import { api } from "../../../services/api"
import "./Memory.scss"
import { useEffect, useState, useRef, useMemo } from "react"
import useFetch from "../../../hooks/useFetch"
import Grid from "./Grid"
import { useTranslation } from "react-i18next"

const useInterval = (callback, delay, duration) => {
  const durationRef = useRef(duration)
  const durationIntervalRef = useRef()

  const handler = () => {
    callback(durationRef)
  }

  useEffect(() => {
    const durationInterval = setInterval(handler, delay)
    durationIntervalRef.current = durationInterval
    return () => {
      clearInterval(durationInterval)
    }
    // eslint-disable-next-line
  }, [delay])

  return durationIntervalRef
}

const Cargando = () => {
  const { t } = useTranslation()
  return (
    <div className="row my-5 py-5">
      <center>{t(`ui.btns.loading`)}...</center>
    </div>
  )
}

const Memory = ({ category, difficulty, winCallback }) => {
  const [cardslist, setCardsList] = useState([])
  const [visibleCards, setVisibleCards] = useState([])
  const [duration, setDuration] = useState(0)
  const [finishedCards, setFinishedCards] = useState([])
  const [, setWinner] = useState(false)

  const checkCards = (firstIndex, secondIndex) => {
    if (
      firstIndex !== secondIndex &&
      cardslist[firstIndex].id === cardslist[secondIndex].id
    ) {
      setFinishedCards([...finishedCards, firstIndex, secondIndex])
      // setProgress(finishedCards.length/cardslist.length);
    } else {
      setTimeout(() => {
        setVisibleCards([])
      }, 600)
    }
  }

  const durationIntervalRef = useInterval(
    (durationRef) => {
      durationRef.current++
      setDuration(durationRef.current)
    },
    1000,
    duration
  )

  useEffect(() => {
    if (finishedCards.length > 0 && finishedCards.length === cardslist.length) {
      setWinner(true)
      winCallback()
      clearInterval(durationIntervalRef.current)
    }
  }, [
    finishedCards,
    finishedCards.length,
    cardslist.length,
    durationIntervalRef,
    winCallback,
  ])

  const { url, opt } = useMemo(
    () =>
      api.games.Memory.Random({
        category,
        difficulty,
      }),
    [category, difficulty]
  )

  const [data, isPending, err] = useFetch({ url, opt })

  useEffect(() => {
    if (!isPending && !err) setCardsList(data)
  }, [isPending, err, setCardsList, data])

  const { t } = useTranslation()

  if (isPending && !err) return <Cargando />

  if (err)
    return (
      <>
        <center>
          <p className="py-5">{t(`ui.msgs.something_went_wrong`)}</p>
        </center>
      </>
    )

  return (
    <div className="row">
      <div className="col-lg-12 col-12">
        <Grid
          cardslist={cardslist}
          visibleCards={visibleCards}
          setVisibleCards={setVisibleCards}
          finishedCards={finishedCards}
          checkCards={checkCards}
        />
      </div>
    </div>
  )
}

export default Memory
